import dotenv from "dotenv";
dotenv.config();

export const config = {
    adentis: {
        host: process.env.REACT_APP_MICROSOFT_ADENTIS_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_ADENTIS_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_ADENTIS_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_ADENTIS_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_ADENTIS_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_ADENTIS_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_ISSUER,
        }
    },
    bee: {
        host: process.env.REACT_APP_MICROSOFT_BEE_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_BEE_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_BEE_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_BEE_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_BEE_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_BEE_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_BEE_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_BEE_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_BEE_ISSUER,
        }
    },
    //microsoft: {
    //    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    //    redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI,
    //    authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
    //    tenantId: process.env.REACT_APP_MICROSOFT_TENANT_ID,
    //    enable: process.env.REACT_APP_MICROSOFT_ENABLE
    //},
    //okta: {
    //    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    //    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
    //    issuer: process.env.REACT_APP_OKTA_ISSUER,
    //},
    loginPage: process.env.REACT_APP_LOGIN_PAGE,
    enable: process.env.REACT_APP_LOGIN_PAGE_ENABLE
};
